import React, { useContext } from 'react';
import { useParams } from 'react-router';
import { useQuery } from '@tanstack/react-query';

import EntityDetail from './EntityDetail';
import Loading from '../../shared/Loading';
import NoDataError from '../../shared/NoDataError';
import useAccountDependencies from '../../../hooks/useAccountDependencies';
import { ApiContext } from '../../../App';
import { getAccount } from '../../../lib/actions/accounts';

export default function AccountIndex() {
  const api = useContext(ApiContext);
  const { id } = useParams();

  const {
    data: account,
    error: accountError,
    isLoading: accountLoading,
  } = useQuery({
    queryKey: ['account', id],
    queryFn: () => getAccount(api, id),
    enabled: !!id,
    retry: false,
  });

  const {
    accountProps: { isLoading },
    accountProps,
  } = useAccountDependencies(account);

  if (accountError) return <NoDataError tag="Account" />;

  if (accountLoading || isLoading) return <Loading className="w-14 h-14" />;

  return (
    <div className="max-w-[90%] mx-auto">
      <EntityDetail props={accountProps} />
    </div>
  );
}
